"use client";

import { useEffect } from "react";
import { pageView } from "@/lib/analytics";

/**
 * Counts a view of the page it is placed in, once its title is known: a tab,
 * a page, an event. `title` null waits -- a page whose title arrives with its
 * data renders this again once it has it.
 */
export function PageView({ id, title }: { id: string; title: string | null }) {
  useEffect(() => {
    if (title !== null) {
      pageView(id, title);
    }
  }, [id, title]);
  return null;
}
